<template>
  <div :class="['loader', { 'is-inline': inline }]">
    <b-iconstack class="loader-icon" :font-scale="scale">
      <b-icon stacked icon="loader-circle-back"/>
      <b-icon stacked icon="loader-circle-front"/>
    </b-iconstack>

    <div class="loader-text" v-if="$slots.default">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    scale: {
      type: [Number, String],
      default: 1
    }
  }
}
</script>

<style lang="scss">
$loader-wrapper-empty-height: 200px !default;

$loader-icon-size: $font-size-base * 5 !default;

$loader-icon-circle-back-color: $primary !default;
$loader-icon-circle-front-color: $gray-300 !default;

$loader-icon-animation-duration: 1.5s !default;

.loader-wrapper {
  position: relative;

  &.empty {
    height: $loader-wrapper-empty-height;
  }
}

.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  z-index: 2000;

  .loader-icon {
    transform: translate(-50%, -50%);
    font-size: $loader-icon-size;

    .bi-loader-circle-front {
      color: $loader-icon-circle-front-color;

      .loader-spinner { transform-origin: center center; animation: loader-spin $loader-icon-animation-duration cubic-bezier(0.8, 0.25, 0.45, 0.8) infinite; }
    }

    .bi-loader-circle-back {
      color: $loader-icon-circle-back-color;
    }
  }

  .loader-text {
    transform: translate(-50%, $loader-icon-size * -0.5);
    width: 80vw;
    font-weight: $font-weight-bold;
    text-align: center;
  }

  &.is-inline {
    display: inline-block;
    position: static;
    width: auto;
    height: auto;
    vertical-align: middle;

    .loader-icon {
      display: block;
      transform: none;
      font-size: inherit;
    }
  }
}

@keyframes loader-spin {
 0% { transform: rotate(0deg); }
 100% { transform: rotate(360deg); }
}
</style>
